import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { base_url } from "../../utils/utils";

export const get_profitability_analysis_report_list = createAsyncThunk(
  "financial_report/get_profitability_analysis",
  async (data, { rejectWithValue }) => {
    try {
      const userIdString = localStorage.getItem("userId");
      const userId = JSON.parse(userIdString)?.aid;

      const body = new FormData();
      body.append("action", "list");
      body.append("agencyid", userId);
      body.append("year", data?.year);
      body.append("from_month", data?.month);
      body.append("to_month", data?.month1);
      body.append("page", data?.page);
      body.append("limit", data?.limit);
      body.append("prod_cat", data?.godown_id || "");

      const response = await fetch(
        base_url + "financial_reports/profitability_analysis_report.php",
        {
          method: "POST",
          body,
        }
      );

      const res = await response.json();
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const get_depreciation_report_list = createAsyncThunk(
  "financial_report/depreciation_report",
  async (data, { rejectWithValue }) => {
    try {
      const userIdString = localStorage.getItem("userId");
      const userId = JSON.parse(userIdString)?.aid;

      const body = new FormData();
      body.append("action", "list");
      body.append("agencyid", userId);
      body.append("FY", data?.fy);

      const response = await fetch(
        base_url + "financial_reports/depreciation_report.php",
        {
          method: "POST",
          body,
        }
      );

      const res = await response.json();
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const get_balance_sheet_report = createAsyncThunk(
  "financial_report/balance_sheet",
  async (data, { rejectWithValue }) => {
    try {
      const userIdString = localStorage.getItem("userId");
      const userId = JSON.parse(userIdString)?.aid;

      const body = new FormData();
      body.append("action", "list");
      body.append("agencyid", userId);
      body.append("FY", data?.fy);

      const response = await fetch(
        base_url + "financial_reports/balance_sheet.php",
        {
          method: "POST",
          body,
        }
      );

      const res = await response.json();
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  profitability_analysis_report: [],
  profitability_analysis_loading: false,
  profitability_analysis_error: null,
  profitability_analysis_totalCount: 0,
  depreciation_report_list: [],
  depreciation_report_loading: false,
  depreciation_report_error: null,
  depreciation_report_totalCount: 0,
  balance_sheet_list: [],
  balance_sheet_loading: false,
  balance_sheet_error: null,
  balance_sheet_totalCount: 0,
};

const finacialReportSlice = createSlice({
  name: "finacial_report",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      // ✅ PENDING
      .addCase(get_profitability_analysis_report_list.pending, (state) => {
        state.profitability_analysis_loading = true;
        state.profitability_analysis_error = null;
      })

      // ✅ FULFILLED
      .addCase(
        get_profitability_analysis_report_list.fulfilled,
        (state, action) => {
          state.profitability_analysis_loading = false;

          if (action.payload?.success) {
            state.profitability_analysis_report = action.payload.data;
            state.profitability_analysis_totalCount = action.payload.totalcount;
          } else {
            state.profitability_analysis_report = [];
            state.profitability_analysis_totalCount = 0;
          }
        }
      )

      // ✅ REJECTED
      .addCase(
        get_profitability_analysis_report_list.rejected,
        (state, action) => {
          state.profitability_analysis_loading = false;
          state.profitability_analysis_error =
            action.payload || "Something went wrong";
          state.profitability_analysis_report = [];
        }
      );

    builder

      // ✅ PENDING
      .addCase(get_depreciation_report_list.pending, (state) => {
        state.depreciation_report_loading = true;
        state.depreciation_report_error = null;
      })

      // ✅ FULFILLED
      .addCase(get_depreciation_report_list.fulfilled, (state, action) => {
        state.depreciation_report_loading = false;

        if (action.payload?.success) {
          state.depreciation_report_list = action.payload.data;
          state.depreciation_report_totalCount = action.payload.totalcount;
        } else {
          state.depreciation_report_list = [];
          state.depreciation_report_totalCount = 0;
        }
      })

      // ✅ REJECTED
      .addCase(get_depreciation_report_list.rejected, (state, action) => {
        state.depreciation_report_loading = false;
        state.depreciation_report_error =
          action.payload || "Something went wrong";
        state.depreciation_report_list = [];
      });

    builder

      // ✅ PENDING
      .addCase(get_balance_sheet_report.pending, (state) => {
        state.balance_sheet_loading = true;
        state.balance_sheet_error = null;
      })

      // ✅ FULFILLED
      .addCase(get_balance_sheet_report.fulfilled, (state, action) => {
        state.balance_sheet_loading = false;

        if (action.payload?.success) {
          state.balance_sheet_list = action.payload.data;
          state.balance_sheet_totalCount = action.payload.totalcount;
        } else {
          state.balance_sheet_list = [];
          state.balance_sheet_totalCount = 0;
        }
      })

      // ✅ REJECTED
      .addCase(get_balance_sheet_report.rejected, (state, action) => {
        state.balance_sheet_loading = false;
        state.balance_sheet_error = action.payload || "Something went wrong";
        state.balance_sheet_list = [];
      });
  },
});

export default finacialReportSlice.reducer;
